import React, { useState } from 'react';
import { Palette, Check, ChevronDown } from 'lucide-react';
import { useTheme, themes } from './ThemeContext';
import './ThemeSwitcher.css';

const ThemeSwitcher = () => {
  const { currentTheme, changeTheme } = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  const currentThemeData = themes[currentTheme];

  return (
    <div className="theme-switcher-container">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="theme-switcher-button-compact"
        aria-label="Change theme"
        title="Change theme"
      >
        <div
          className="theme-current-indicator"
          style={{ background: currentThemeData.primary }}
        />
        <ChevronDown size={16} className={`theme-chevron ${isOpen ? 'open' : ''}`} />
      </button>

      {isOpen && (
        <>
          <div
            className="theme-switcher-backdrop"
            onClick={() => setIsOpen(false)}
          />
          <div className="theme-switcher-dropdown-grid">
            {/* Grid Header */}
            <div className="theme-header-grid">
              <Palette size={16} />
              <span>Themes</span>
            </div>

            {/* Multi-Column Color Icon Grid */}
            <div className="theme-grid-icons">
              {Object.entries(themes).map(([key, theme]) => (
                <button
                  key={key}
                  onClick={() => {
                    changeTheme(key);
                    setTimeout(() => setIsOpen(false), 200);
                  }}
                  className={`theme-icon-btn ${currentTheme === key ? 'active' : ''}`}
                  title={`${theme.name} - ${theme.category}`}
                  aria-label={`Switch to ${theme.name} theme`}
                >
                  <div
                    className="theme-icon-bg"
                    style={{
                      background: `linear-gradient(135deg, ${theme.primary}, ${theme.primaryLight})`,
                    }}
                  >
                    <span className="theme-emoji">{theme.icon}</span>
                  </div>
                  {currentTheme === key && (
                    <div className="active-indicator">
                      <Check size={14} strokeWidth={3} />
                    </div>
                  )}
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ThemeSwitcher;
